var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterYoutube1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9247 18.5831C20.9502 19.738 19.2965 19.6923 17.9032 19.7886C13.7498 20.0753 9.25245 20.0656 5.0957 19.7886C2.99404 19.6484 0.962616 19.6231 0.400021 17.1868C-0.0690592 15.155 -0.0296249 12.5242 0.0462391 10.4378C0.111587 8.6436 0.028212 5.75881 1.83843 4.77528C2.86861 4.21528 5.36836 4.14612 6.59683 4.0948C10.1358 3.94681 13.8039 3.97172 17.338 4.17214C19.416 4.29002 21.8534 4.15392 22.5302 6.57985C23.0819 8.55696 23.0297 11.4626 22.9527 13.5211C22.8986 14.9661 22.8794 17.4519 21.9247 18.5831ZM9.24607 8.63282V15.3261L15.1052 11.9612L9.24607 8.63282Z",
    fill: "#4B5563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterYoutube1);
export default __webpack_public_path__ + "static/media/footer_youtube1.ac277733dd39a6ef6085ebf0adf57863.svg";
export { ForwardRef as ReactComponent };